import { render, staticRenderFns } from "./OBlockList.vue?vue&type=template&id=1870dd8a&"
import script from "./OBlockList.vue?vue&type=script&lang=js&"
export * from "./OBlockList.vue?vue&type=script&lang=js&"
import style0 from "./OBlockList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports